import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import ProductServices from "../../../services/Product";
import AdjustmentForm from "./components/adjustmentForm";

const AddStock = () => {

  const route = all_routes;
  const navigate = useNavigate();

  // *For Loading
  const [loading, setLoading] = useState(false);

  // *For Inventory Adjustment
  const inventoryAdjustment = async (payload) => {
    setLoading(true)
    try {
      await ProductServices.inventoryAdjustment(payload)
      SuccessToaster('Inventory Adjust Successfully')
      navigate(route?.manageStock)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content p-2">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Stock Management</h4>
              <h6>Adjust Stock</h6>
            </div>
          </div>
        </div>
        <AdjustmentForm onSubmit={inventoryAdjustment} loading={loading} />
      </div>
    </div>
  );
};

export default AddStock;
